import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MainState } from '../main/main.state';
import { ImageInfo } from '../main/models/file-info';
import { ImageStatePort } from '@jax-data-science/sci-image-visualizer';
import { IImageInfo } from '@jax-data-science/sci-image-visualizer';

/**
 * Host-side implementation of the visualization library's {@link ImageStatePort}.
 * Delegates entirely to {@link MainState} (the facade methods the visualization
 * used were themselves thin delegations to it). Bound to the `IMAGE_STATE_PORT`
 * token in `app.module.ts`.
 */
@Injectable({ providedIn: 'root' })
export class ImageStateAdapter implements ImageStatePort {
  constructor(private mainState: MainState) {}

  getFilename$(): Observable<string | undefined> { return this.mainState.getFilename(); }
  isImageCached$(): Observable<boolean> { return this.mainState.isImageCached$(); }
  getImageInfo$(): Observable<IImageInfo | null> { return this.mainState.getImageInfo$(); }
  getImageLoadingMessage$(): Observable<string> { return this.mainState.getImageLoadingMessage$(); }
  getCacheProgress$(): Observable<number | null> { return this.mainState.getCacheProgress$(); }
  getPanelWidth$(): Observable<number> { return this.mainState.getPanelWidth(); }
  isImageLoading$(): Observable<boolean> { return this.mainState.isImageLoading$(); }
  isZoom$(): Observable<boolean> { return this.mainState.isZoom$(); }

  setImageInfo(info: Partial<IImageInfo>): void { this.mainState.setImageInfo$(info as ImageInfo); }
  setImageLoading(loading: boolean): void { this.mainState.setImageLoading(loading); }
  setImageLoadingMessage(message: string): void { this.mainState.setImageLoadingMessage(message); }
  setZoom(zoom: boolean): void { this.mainState.setZoom(zoom); }
  setImageCached(cached: boolean): void { this.mainState.setImageCached(cached); }
  setLoadingError(error: boolean): void { this.mainState.setLoadingError(error); }
  setDiagram(diagram: unknown): void { this.mainState.setDiagramData(diagram); }
}
